import styled from 'styled-components'

export const ContentWrapper = styled.div`
  display: flex;
  gap: 18px;
  height: 130px;
  flex-direction: column;
  justify-content: center;
`

export const ContainerAlerta = styled.div`
  width: 100%;
  display: grid;
  gap: 16px;
  justify-items: center;
`

export const MensagemAlerta = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.cor9}!important;
`

export const TituloAlerta = styled.h1`
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.cor9}!important;
`

export const InputRadioGrupo = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 12px;
  width: 275px;
  position: relative;
`

export const Text = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.designSystem.text.title};
`
